import { collectVideoProjectFromMessages } from '@/constants/utils/video_project';

// Task artifacts survive transcript pagination and compaction. Keep them in
// the studio even when the chat currently renders only the newest messages.
export function collectVideoStudioInventory({ messages = [], task, taskId, conversationId, summary } = {}) {
  const ownsTask = taskId && String(task?.id || task?._id || '') === String(taskId)
    && (!task?.conversationId || String(task.conversationId) === String(conversationId));
  const artifacts = ownsTask && Array.isArray(task.artifacts)
    ? task.artifacts.map(artifact => ({ ...artifact, taskId }))
    : [];
  // Original attachments can be outside the currently loaded chat page.
  // Task context keeps file names and IDs in matching order; previews resolve
  // their URLs through the authenticated file API when needed.
  const referenceFiles = ownsTask && Array.isArray(task.context?.fileIds)
    ? task.context.fileIds.map((id, index) => ({ id, name: task.context.files?.[index] || '' }))
      .filter(file => file.id && file.name)
    : [];
  return collectVideoProjectFromMessages([
    { parameters: { coworkerArtifacts: artifacts }, files: [...referenceFiles,
      ...(ownsTask && Array.isArray(task.referenceFiles) ? task.referenceFiles : [])] },
    ...messages,
  ], { summary });
}

export async function loadVideoStudioScript({ conversationId, fetchPage, isCurrent = () => true }) {
  let beforeIndex;
  while (isCurrent()) {
    const response = await fetchPage(conversationId, { limit: 80, ...(beforeIndex !== undefined ? { beforeIndex } : {}) });
    if (!isCurrent()) return '';
    const { scriptText } = collectVideoProjectFromMessages(response?.messages || []);
    if (scriptText) return scriptText;
    const next = response?.pagination?.nextBeforeIndex;
    if (!response?.pagination?.hasMore || !Number.isFinite(next) || next < 0
      || (beforeIndex !== undefined && next >= beforeIndex)) return '';
    beforeIndex = next;
  }
  return '';
}
